export const HOST_INVOICE_FIXTURE_ENABLED =
  process.env.NODE_ENV !== "production" && process.env.REACT_APP_HOST_INVOICE_FIXTURE === "true";

export const HOST_INVOICE_FIXTURES = [
  {
    id: "fixture-invoice-1",
    invoice_number: "INV-2026-TEST-0001",
    created_at: Date.UTC(2026, 8, 1),
    payout_reference: "po_test_domits_0001",
    host_name: "Demo Host",
    host_company_name: "Demo Holiday Rentals",
    property_name: "Canal House Amsterdam",
    property_id: "fixture-property-1",
    booking_id: "fixture-booking-1",
    guest_name: "Test Guest",
    arrival_date: Date.UTC(2026, 7, 1),
    departure_date: Date.UTC(2026, 7, 4),
    nights: 3,
    rate_per_night: 150,
    gross_amount: 450,
    commission_amount: 45,
    net_amount: 405,
    currency: "EUR",
    status: "finalized",
  },
  {
    id: "fixture-invoice-2",
    invoice_number: "INV-2026-TEST-0002",
    created_at: Date.UTC(2026, 8, 3),
    payout_reference: "po_test_domits_0002",
    host_name: "Demo Host",
    property_name: "Beach Apartment Rotterdam",
    property_id: "fixture-property-2",
    booking_id: "fixture-booking-2",
    guest_name: "Another Test Guest",
    arrival_date: Date.UTC(2026, 7, 12),
    departure_date: Date.UTC(2026, 7, 14),
    nights: 2,
    rate_per_night: 110,
    gross_amount: 220,
    commission_amount: 22,
    net_amount: 198,
    currency: "EUR",
    status: "draft",
  },
];
